<ng-container *ngIf="!!fault && (((fault.loadState$ | async)?.status) === loadState.Loaded || (!!isInitialized && ((fault.loadState$ | async)?.status) !== loadState.Loaded)); else placeholder">
  <div class="fault-tile-container" [class.fault-tile-container-popup]="initAsPlanViewerPopup && !appContainerService.isMobileView" [class.selected]="isSelected"
       [style.pointer-events]="initAsPlanViewerPopup && deviceService.isTablet() ? 'auto' : null">
    <div *ngIf="initAsPlanViewerPopup && deviceService.isTablet() && (selectionService.selectionMode | async) !== true" class="open-detail-button-wrapper">
      <button class="open-detail-button" (click)="openDetailView($event)">
        <mydocma-custom-mat-icon [iconName]="'_edit'"></mydocma-custom-mat-icon>
      </button>
    </div>
    <div
      #ref
      [style]="'min-height: ' + minTileHeight + 'px !important;'"
      [class]="'fault-tile'" [class.selected]="isSelected"
        (click)="onClick($event)"
        (touchstart) ="onMouseOver($event)"
        (mouseenter)='onMouseOver($event)'
        (mouseleave)='onMouseLeave($event)'
    >
    <ng-container *ngIf="isLoaded || !initAsPlanViewerPopup; else popupLoader">
      <div class="tile-header">
        <div style="display: flex; flex-direction: row">
          <div class="tile-sync-state-header" [class.notSynced]="overallSyncStatus === overallSyncStatusEnum.notSynced" [class.syncError]="overallSyncStatus === overallSyncStatusEnum.syncError"></div>

          <div class="tile-header-row" [class.selected]="isSelected">
            <div class="tile-header-row1">
              <mydocma-custom-mat-icon *ngIf="isLocked" class="tile-icon default-marker" iconName="_lock2" style="align-self: center; grid-column: 1"></mydocma-custom-mat-icon>

                <div  class="tile-text-small tile-text-numbers">
                {{(fault?.loadState?.status === loadState.Loaded ? (fault.data?.Number1 ? fault.data.Number1 : '') + (fault.data?.Number1 && fault.data?.Number2 ? ' - ' : '') + (fault.data?.Number2 ? fault.data.Number2 : '') : '')}}
              </div>
              <div class="tile-downloaded-icon" *ngIf="fault?.downloaded && !initAsPlanViewerPopup">
                <mydocma-custom-mat-icon [iconName]="'_local_saved'"></mydocma-custom-mat-icon>
              </div>
              <div class="fault-view-menu" *ngIf="fault && fault.changeState?.status !== changeStatusEnum.New && (!initAsPlanViewerPopup || deviceService.isTablet()) && (selectionService.selectionMode | async) === false" style="align-self: center; width: 24px; height: 24px; grid-column: 3; margin-left: 8px">
                <button mat-icon-button
                        (menuOpened)="onMenuOpened()"
                        (menuClosed)="onMenuClosed()"
                        [matMenuTriggerFor]="faultTileMenu" style="line-height: 24px; width: 24px; height: 24px; touch-action: manipulation"
                  *ngIf="true"
                  (click)="$event.stopPropagation()">
                  <mydocma-custom-mat-icon
                    [iconName]="'more_horiz'">
                  </mydocma-custom-mat-icon>
                </button>
              </div>
              <div class="fault-view-menu"*ngIf="showCloseButton" style="align-self: center; width: 24px; height: 24px; grid-column: 3">
                <button mat-icon-button

                        (click)="onCloseButtonClicked.emit(true)">
                  <mydocma-custom-mat-icon
                    [iconName]="'close'">
                  </mydocma-custom-mat-icon>
                </button>
              </div>

              <mat-menu #faultTileMenu="matMenu">
                <button mat-menu-item
                        *ngIf="(permissionService.hasShortcuts$ | async) && (permissionService.shortcuts$ | async).length > 0 && (permissionService.permissionNewActivity$ | async) === true"
                        [class.disabled-button]="isLocked || (faultsState$ | async).SelectedFaultsCount > this.maxCountFaultsNewActivity"
                        [class.mydocma-shortcut-blocked]="isIosMobile && !canOpenShortcut"
                        [matMenuTriggerFor]="(isIosMobile && !canOpenShortcut) ? null : shortcutMenu"
                        #shortcutTrigger="matMenuTrigger"
                        (pointerdown)="onShortcutButtonPointerDown()"
                        (menuOpened)="onShortcutMenuAutoOpen()"
                        [disabled]="isLocked || (faultsState$ | async).SelectedFaultsCount > this.maxCountFaultsNewActivity">
                  <mydocma-custom-mat-icon
                    matTooltip="{{'MM.general.button.newActivity' | translate }} {{isLocked ? lockedMessage() : ''}}"
                    [iconName]="'_flag-2'"></mydocma-custom-mat-icon>
                  {{  'MM.general.button.shortcuts' | translate }}
                </button>

                <mat-menu #shortcutMenu="matMenu">
                  <button class="mat-menu-item" *ngFor="let sc of (permissionService.shortcuts$ | async)"
                          (click)="addActivitiesByShortcut(sc)"
                          [disabled]="(permissionService.permissionNewActivity$ | async) === false || isLocked || (faultsState$ | async).SelectedFaultsCount > this.maxCountFaultsNewActivity">
                    <mydocma-custom-mat-icon [iconName]="IconName(sc)"></mydocma-custom-mat-icon>
                    {{ sc.Status.Name1 + (sc.Status.Name2 ? ' - ' + sc.Status.Name2 : '') }}
                  </button>
                  <button class="mat-menu-item"
                          matTooltip="{{'MM.general.button.newActivity' | translate }}"
                          [class.disabled-button]="isLocked"
                          (click)="addActivities()"
                          [disabled]="(permissionService.permissionNewActivity$ | async) === false || isLocked || (faultsState$ | async).SelectedFaultsCount > this.maxCountFaultsNewActivity">
                    <mydocma-custom-mat-icon [iconName]="'_flag-2'"></mydocma-custom-mat-icon>
                    {{  'MM.general.button.newActivity' | translate }}
                  </button>
                </mat-menu>


                <button [disabled]="isLocked || hasChanges()" [class.disabled-button]="isLocked || hasChanges()" mat-menu-item (click)="onCreateWritingClick()">
                  <mydocma-custom-mat-icon [iconName]="'_send-letter'"
                                           matTooltip="{{'MM.general.button.writing' | translate }} {{isLocked ? lockedMessage() : ''}}"></mydocma-custom-mat-icon>
                  {{'MM.general.button.writing' | translate }}
                </button>
                <button [disabled]="hasChanges()" [class.disabled-button]="hasChanges()" mat-menu-item (click)="startFaultListReport()">
                  <mydocma-custom-mat-icon fontSet="material-icons-outlined"
                                           matTooltip="{{'MM.reporting.report' | translate }} {{isLocked ? lockedMessage() : ''}}"
                                           [iconName]="'description'"></mydocma-custom-mat-icon>
                  {{'MM.reporting.report' | translate }}
                </button>

                <button [disabled]="(faultsState$ | async).IsAnyFaultLocked || (!deviceService.isTablet() && (rightPaneService.isUndocked$ | async))" [class.disabled-button]="(faultsState$ | async).IsAnyFaultLocked || (!deviceService.isTablet() && (rightPaneService.isUndocked$ | async))" *ngIf="fault?.pin && (faultActionsService.permissionAddAttachment$ | async)" mat-menu-item
                        (click)="faultActionsService.onPlanClipping(this.fault, this)">
                  <mydocma-custom-mat-icon [iconName]="'_plan_modell_section'"></mydocma-custom-mat-icon>
                  {{'MM.general.button.addPlanSection' | translate}}
                </button>

                <button [disabled] ="connectivityService.isOffline| async" *ngIf="platformModeStateService.isLocalModeEnabled$ | async" mat-menu-item (click)="onFaultDownloadClick()">
                  <mydocma-custom-mat-icon [iconName]="'_local_save'"></mydocma-custom-mat-icon>
                  {{ 'MM.general.button.download' | translate }}
                </button>

                <button *ngIf="fault.downloaded" mat-menu-item (click)="onReloadAttachmentsClick()">
                  <mydocma-custom-mat-icon [iconName]="'_attach_load'"></mydocma-custom-mat-icon>
                  {{ 'MM.general.button.loadAllAttachments' | translate }}
                </button>

                <button *ngIf="fault.downloaded" mat-menu-item (click)="onRemoveFaultClick()">
                  <mydocma-custom-mat-icon [iconName]="'_local_remove'"></mydocma-custom-mat-icon>
                  {{ 'MM.general.button.removeDownload' | translate }}
                </button>

                <button [disabled]="isLocked || hasChanges()" [class.disabled-button]="hasChanges() || isLocked" *ngIf="!fault?.pin" (click)="faultActionsService.onLocatePinOnPlan(this.fault, this)" mat-menu-item>
                  <mydocma-custom-mat-icon [iconName]="'_plan-view'"></mydocma-custom-mat-icon>
                  {{'MM.general.button.locateOnPlan' | translate }}
                </button>

                <button [disabled]="isLocked || hasChanges()" [class.disabled-button]="isLocked || hasChanges()" *ngIf="!(platformModeStateService.isLocalMode$ | async) && fault?.pin && (permissionDeletePins$ | async)" mat-menu-item (click)="onDeletePin()">
                  <mydocma-custom-mat-icon [iconName]="'_pin-delete'"></mydocma-custom-mat-icon>
                  {{'MM.plan.removePin' | translate }}
                </button>

                <button mat-menu-item (click)="addToPool()" [disabled]="hasChanges()"
                  *ngIf="(permissionDefectPoolsAddDefects$ | async)">
                  <mydocma-custom-mat-icon fontSet="material-icons-outlined" [iconName]="'_defect_pool_add'"></mydocma-custom-mat-icon>
                  {{'MM.general.button.addToPool' | translate }}
                </button>

                <button mat-menu-item (click)="removeFromPool()" [disabled]="hasChanges()"
                  *ngIf="(permissionDefectPoolsRemoveDefects$ | async)">
                  <mydocma-custom-mat-icon fontSet="material-icons-outlined" [iconName]="'_defect_pool_remove'"></mydocma-custom-mat-icon>
                  {{'MM.general.button.removeFromPool' | translate }}
                </button>

                <button [disabled]="isLocked || hasChanges()" [class.disabled-button]="isLocked || hasChanges()"
                        *ngIf="permissionDuplicateFault$ | async" mat-menu-item (click)="onDuplicateClick()">
                  <mydocma-custom-mat-icon fontSet="material-icons-outlined" [iconName]="'content_copy'"></mydocma-custom-mat-icon>
                  {{'MM.fault.duplicate.button' | translate }}
                </button>

                <button [disabled]="isLocked || hasChanges()" [class.disabled-button]="isLocked || hasChanges()" *ngIf="!(platformModeStateService.isLocalMode$ | async) && (permissionDelete$ | async)" mat-menu-item (click)="onDeleteClick()">
                  <mydocma-custom-mat-icon [iconName]="'_delete'"></mydocma-custom-mat-icon>
                  {{'MM.general.button.delete' | translate }}
                </button>
              </mat-menu>

            </div>

            <div  class="tile-header-row2 ">
              <div style="display: grid; grid-template-columns: auto 24px">
                <div class="tile-header-description" *ngIf="fault">{{fault.data?.Desc1_1}}</div>
                <div class="tile-header-checkbox">
                  <mat-checkbox
                    class="select-checkbox tile-select-checkbox"
                    [class.multi-select]="selectionMode"
                    [class.hover]= "isHovered"
                    [checked]="isChecked"
                    (click)="$event.stopPropagation()"
                    (change)="changeChecked($event)">
                  </mat-checkbox>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div class="tile-body">

        <div style="display: flex; flex-direction: row">
          <div class="tile-sync-state-body" [class.notSynced]="overallSyncStatus === overallSyncStatusEnum.notSynced" [class.syncError]="overallSyncStatus === overallSyncStatusEnum.syncError"></div>

          <div class="tile-sync-state-body-content" [class.selected]="isSelected">

            <div *ngIf="sizeMode === sizeModesEnum.Normal" [class.grid-body]="!initAsPlanViewerPopup" [class.grid-body-mobile]="!!initAsPlanViewerPopup">
              <div style="margin-right: 6px">
                <ng-container *ngIf="sizeMode === sizeModesEnum.Normal">
                  <ng-container *ngTemplateOutlet="bodyContent"></ng-container>
                </ng-container>
              </div>

              <ng-container *ngIf="showAttachments">
              <div *ngIf="((!!attachmentLeft || !!attachmentRight) && !(appContainerService.isMobileView && initAsPlanViewerPopup))" class="grid-body" style="margin-left: 6px">
                <div class="attachment-container" style="height: 116px; display: flex; margin-right: 4px; position: relative;">
                  <ng-container *ngIf="!initAsPlanViewerPopup">
                    <ng-container *ngTemplateOutlet="imgSource; context: {$implicit: (attachmemntLeft$ | async), showCount: false}"></ng-container>
                  </ng-container>
                </div>
                <div class="attachment-container" style="height: 116px; display: flex; margin-left: 4px; position: relative;">
                  <ng-container *ngTemplateOutlet="imgSource; context: {$implicit: (attachmemntRight$ | async), showCount: true}"></ng-container>
                </div>
              </div>

              <div *ngIf="!attachmentLeft && !attachmentRight && !initAsPlanViewerPopup" class="grid-body" style="margin-left: 6px">
                <div style="height: 116px; margin-right: 4px;">
                </div>
                <div style="height: 116px; margin-left: 4px;">
                  <div class="add-attachment" *ngIf="isLoaded && sizeMode === sizeModesEnum.Normal && !initAsPlanViewerPopup" (click)="onAddAttachmentsClick()">
                    <input
                      [id]="'uploader-file-input' + guid"
                      class="file-input"
                      type="file"
                      (change)="onFileInputChange($event)"
                      [accept]="'*'"
                      [multiple]="true"
                      [disabled]="false"
                      style="display: none">
                    <label [for]="'uploader-file-input' + guid" class="add-attachment-input" #openFileSystem style="display: none">
                    </label>
                    <mydocma-custom-mat-icon class="add-attachment-icon default-marker" iconName="_add-attachment-placeholder">
                    </mydocma-custom-mat-icon>
                  </div>
                </div>
              </div>
              </ng-container>
            </div>

            <ng-container *ngIf="sizeMode === sizeModesEnum.Narrow">
              <ng-container *ngTemplateOutlet="bodyContent" style="flex-shrink: 0"></ng-container>
              <ng-container *ngIf="showAttachments">
              <div *ngIf=" ((!!attachmentLeft || !!attachmentRight) && !(appContainerService.isMobileView && initAsPlanViewerPopup))" [class.grid-body]="!!(attachmemntLeft$ | async)" style="margin-top: 12px;">
                <div class="attachment-container" *ngIf="!!(attachmemntLeft$ | async)" style="height: 116px; display: flex; margin-right: 4px; position: relative;">
                  <ng-container *ngIf="!initAsPlanViewerPopup">
                    <ng-container *ngTemplateOutlet="imgSource; context: {$implicit: (attachmemntLeft$ | async), showCount: false}"></ng-container>
                  </ng-container>
                </div>
                <div class="attachment-container" style="height: 116px; display: flex; position: relative;" [class.narrow-one-tiles]="!!(attachmemntLeft$ | async)" [class.narrow-two-tiles]="!!(attachmemntLeft$ | async)">
                  <ng-container *ngTemplateOutlet="imgSource; context: {$implicit: (attachmemntRight$ | async), showCount: true}"></ng-container>
                </div>
              </div>
              <div class="add-attachment" *ngIf="isLoaded && !attachmentLeft && !attachmentRight && !initAsPlanViewerPopup" style="margin: 12px 0 0 0;" (click)="onAddAttachmentsClick()">
                <input
                  [id]="'uploader-file-input' + guid"
                  class="file-input"
                  type="file"
                  (change)="onFileInputChange($event)"
                  [accept]="acceptedTypes"
                  [multiple]="true"
                  [disabled]="false"
                  style="display: none">
                <label [for]="'uploader-file-input' + guid" class="add-attachment-input" #openFileSystem style="display: none">
                </label>
                <mydocma-custom-mat-icon class="add-attachment-icon default-marker" iconName="_add-attachment-placeholder">
                </mydocma-custom-mat-icon>
              </div>
              </ng-container>
            </ng-container>
          </div>

        </div>
      </div>
    </ng-container>
    </div>
  </div>
</ng-container>

<ng-template #bodyContent>
    <div class="tile-text-small" style="margin: 0 0 8px 0">
      <mydocma-custom-mat-icon class="tile-icon default-marker" [iconName]="(isLoaded && structurePath ? '_stacked-organizational-chart-highlighted-first-node' : '')"></mydocma-custom-mat-icon>
      <div class="tile-text-small overflow-left-side" [matTooltip]="structurePath">
        {{structurePath}}
      </div>
    </div>

    <div class="tile-text-small" *ngIf="hasCompanyPermission" style="margin: 0 0 8px 0">
      <mydocma-custom-mat-icon *ngIf="hasCompanyPermission" class="tile-icon default-marker" [iconName]="(isLoaded ? '_company-config' : '')"></mydocma-custom-mat-icon>
      <div class="tile-text-small overflow-left-side" *ngIf="hasCompanyPermission" [matTooltip]="companyName">
        {{companyName}}
      </div>
    </div>
    <div class="tile-text-small" *ngIf="hasCraftPermission" style="margin: 0 0 8px 0">
      <mydocma-custom-mat-icon *ngIf="hasCraftPermission" class="tile-icon default-marker" [iconName]="(isLoaded ? '_crafts' : '')"></mydocma-custom-mat-icon>
      <div class="tile-text-small overflow-left-side" *ngIf="hasCraftPermission" [matTooltip]="craftName">
        {{craftName}}
      </div>
    </div>

    <div style="display: flex; flex-direction: column;">
      <div class="tile-text-small" style="margin: 8px 0 4px 0; padding-right: 12px !important;">
        <ng-container *ngIf="(viewActivitiesCO$ | async) === true, else coPlaceholder">
          <div *ngIf="!delayGroupSC && !delayGroupSCImageName" class="delay-image"></div>
          <mydocma-custom-mat-icon *ngIf="!!delayGroupSCImageName && delayGroupSCImageName === '_delay-no-duedate'" class="delay-image delay-image-color-no-duedate" [iconName]="delayGroupSCImageName"></mydocma-custom-mat-icon>
          <mydocma-custom-mat-icon *ngIf="!!delayGroupSCImageName && delayGroupSCImageName === '_delay-resolved'" class="delay-image delay-image-color-resolved" [iconName]="delayGroupSCImageName"></mydocma-custom-mat-icon>
          <img [src]='delayGroupSC' *ngIf="!!delayGroupSC"  class="delay-db-image">

          <div class="delay-text">{{(lastActivitySC?.data?.Status ? ('MM.activity.type.SC' | translate) + ': ' + lastActivitySC.data.Status.Name1 + ' - ' + lastActivitySC.data.Status.Name2 : '')}}</div>
        </ng-container>
        <ng-template #coPlaceholder>
          <div class="co-ct-placeholder"></div>
        </ng-template>
      </div>

      <div class="tile-text-small" style="padding-right: 12px !important;">
        <ng-container *ngIf="(viewActivitiesCT$ | async) === true, else ctPlaceholder">
          <div *ngIf="!delayGroupCT && !delayGroupCTImageName" class="delay-image"></div>
          <mydocma-custom-mat-icon *ngIf="!!delayGroupCTImageName && delayGroupCTImageName === '_delay-no-duedate'" class="delay-image delay-image-color-no-duedate" [iconName]="delayGroupCTImageName"></mydocma-custom-mat-icon>
          <mydocma-custom-mat-icon *ngIf="!!delayGroupCTImageName && delayGroupCTImageName === '_delay-resolved'" class="delay-image delay-image-color-resolved" [iconName]="delayGroupCTImageName"></mydocma-custom-mat-icon>
          <img [src]='delayGroupCT' *ngIf="!!delayGroupCT" class="delay-db-image">

          <div class="delay-text">{{(lastActivityCT?.data?.Status ? ('MM.activity.type.CT' | translate) + ': ' + lastActivityCT.data.Status.Name1 + ' - ' + lastActivityCT.data.Status.Name2 : '')}}</div>
        </ng-container>
        <ng-template #ctPlaceholder>
          <div class="co-ct-placeholder"></div>
        </ng-template>
      </div>
    </div>
</ng-template>

<ng-template #placeholder>
  <div class="fault-tile-container" [class.selected]="isSelected">
    <div [class]="'fault-tile'"
         [style]="'min-height: ' + minTileHeight + 'px !important;'"
         [class.selected]="isSelected" style="background-color: white">
      <div class="tile-header">
      </div>
    </div>
  </div>
</ng-template>

<ng-template #noAttachment>
<!--  <mydocma-custom-mat-icon class="attachment-load-status-icon default-marker" iconName="no_photography"></mydocma-custom-mat-icon>-->
</ng-template>

  <ng-template #imgSource let-param let-showCount="showCount">
  <ng-container *ngIf="param; else noAttachment">
    <ng-container [ngSwitch]="param.Source?.loadState?.status">
      <ng-container *ngSwitchCase="loadStatusEnum.Loading">
        <mydocma-loader [size]="'small'" style="position: absolute; width: 100%; height: 100%"></mydocma-loader>
        <img *ngIf="param.Source.url"
             [src]="param.Source.url" class="at-thumbnail" [alt]="param.Source.name"
             [class.attachment-type-plan-section]="param.Attachment.data.Type === attachmentTypes.PlanSection"
             style="display: block; object-fit: cover; width: 100%; height: 100%; border-radius: 4px; background-color: transparent;">
      </ng-container>
      <ng-container *ngSwitchCase="loadStatusEnum.Error">
        <mydocma-custom-mat-icon class="attachment-load-status-icon default-marker" iconName="no_photography"></mydocma-custom-mat-icon>
      </ng-container>
      <ng-container *ngSwitchCase="loadStatusEnum.NotLoaded">
        <ng-container *ngIf="(platformModeStateService.isLocalMode$ | async); else showIcon">
          <div class="notLoaded-container">
              <span class="notLoaded-text">{{ 'MM.attachment.errors.notLoaded' | translate }}</span>
          </div>
        </ng-container>
        <ng-template #showIcon>
          <mydocma-custom-mat-icon class="attachment-load-status-icon default-marker" iconName="cloud_download"></mydocma-custom-mat-icon>
        </ng-template>
      </ng-container>
      <ng-container *ngSwitchCase="loadStatusEnum.Loaded">
        <img (click)="onTileClick($event, param.Attachment)"
             [src]="param.Source.url" class="at-thumbnail" [alt]="param.Source.name"
             [class.attachment-type-plan-section]="param.Attachment.data.Type === attachmentTypes.PlanSection"
             style="display: block; object-fit: cover; width: 100%; height: 100%; border-radius: 4px; background-color: transparent;">

        <div class="attachments-hover" (click)="onTileClick($event, param.Attachment)"></div>
        <div *ngIf="showCount && allAttachments.length > 2 && !initAsPlanViewerPopup" class="attachments-count-info">+{{allAttachments.length - 2}}</div>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-template>
<ng-template #popupLoader>
  <div style="flex: 1; border-radius: 8px; display: flex; align-items: center; justify-content: center; height: 100%; width: 100%; background-color: white;">
    <mydocma-loader [size]="'small'"></mydocma-loader>
  </div>
</ng-template>
